import { useTheme } from '@material-ui/core/styles';
import ReactECharts from 'echarts-for-react';

interface BarChartProps {
    title: string;
    xAxisData: string[];
    seriesData: number[];
    seriesName?: string;
}
const BarChart = ({
    title,
    xAxisData,
    seriesData,
    seriesName,
}: BarChartProps) => {
    const theme = useTheme();

    const option = {
        title: {
            text: title,
            left: 'right',
            textStyle: {
                color: theme.palette.primary.main,
                fontStyle: 'normal',
                fontWeight: 500,
                fontFamily: 'Poppins',
                fontSize: 16,
            },
        },
        tooltip: {},
        xAxis: {
            data: xAxisData,
        },
        yAxis: {
            max: Math.max(5, Math.max(...seriesData)),
        },
        series: [
            {
                name: seriesName,
                type: 'bar',
                data: seriesData,
                itemStyle: {
                    color: theme.palette.primary.main,
                },
            },
        ],
    };

    return (
        <ReactECharts
            option={option}
            style={{ height: '100%', width: '100%' }}
        />
    );
};

export default BarChart;
